// extracted by mini-css-extract-plugin
module.exports = {"errorPageContainer":"styles_errorPageContainer__1NHUT"};